import styled from 'styled-components';

import {colors} from '@app/styles/theme';

export const GapValue = styled.div`
    display: flex;
    align-items: baseline;
    gap: 12px;

    & > span:last-child {
        color: ${colors.textSecondary};
        font-size: 16px;
        font-weight: 600;
    }
`;

export const Chart = styled.div`
    height: 280px;
    width: 100%;

    canvas {
        display: block;
    }
`;

export const SummaryContent = styled.div`
    position: relative;
`;

export const SpinnerOverlay = styled.div`
    position: absolute;
    inset: 0;
    z-index: 2;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding-top: 20vh;
    background: rgba(255, 255, 255, 0.5);
    pointer-events: none;

    > * {
        position: sticky;
        top: 20vh;
        bottom: 20vh;
    }
`;
